import { render, staticRenderFns } from "./ProjetoPainel.vue?vue&type=template&id=0021776a&"
import script from "./ProjetoPainel.vue?vue&type=script&lang=js&"
export * from "./ProjetoPainel.vue?vue&type=script&lang=js&"
import style0 from "./ProjetoPainel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports